module.exports = require('./helpers/bundle-url').getBundleURL('iGguq') + "logo-dark.eefe0b7f.svg";